export enum TemplateStatuses {
	None = 'none',
	Loading = 'loading',
	Done = 'done',
	Error = 'error',
}
